import type { Transfer } from '../types/transfer/Transfer';
import type { TAB_TYPE } from '../types/actionBars';

type Params = {
  transfer: Transfer;
  transfersType: TAB_TYPE;
  hasCreateRequestPermission: boolean;
  assignedOutletIds: number[];
  selectedOutletIds: number[];
};

export const shouldShowTabList = (
  tabPermissions: string[],
  transfersType: string
) => {
  /**
   * All, Completed, and Rejected tabs are public access
   */
  if (['ALL', 'COMPLETED', 'REJECTED'].includes(transfersType)) return true;

  if (tabPermissions.includes(transfersType)) return true;

  if (transfersType === 'APPROVAL' && tabPermissions.includes('APPROVE'))
    /**
     * This must be done because there is incosistent between client and server state
     * either APPROVE (API) or APPROVAL (Client)
     */
    return true;

  return false;
};

export const shouldShowDeleteButton = (params: Params) => {
  const {
    transfer,
    transfersType,
    hasCreateRequestPermission,
    assignedOutletIds,
    selectedOutletIds,
  } = params;
  const { status_key: statusKey, to_outlet_id: toOutletId } = transfer;
  const isAllOutletSelected = selectedOutletIds.length > 1;

  if (!['ALL', 'REJECTED'].includes(transfersType)) {
    return false;
  }

  if (!hasCreateRequestPermission) {
    return false;
  }

  const allowedStatusKey = ['WAITING_FOR_APPROVAL', 'REVISE_NEEDED'];
  if (!allowedStatusKey.includes(statusKey)) {
    return false;
  }

  if (isAllOutletSelected && !assignedOutletIds.includes(toOutletId)) {
    return false;
  }

  if (!isAllOutletSelected && !selectedOutletIds.includes(toOutletId)) {
    return false;
  }

  return true;
};
